import { render, staticRenderFns } from "./BannerSlider.vue?vue&type=template&id=28140c19"
import script from "./BannerSlider.vue?vue&type=script&lang=js"
export * from "./BannerSlider.vue?vue&type=script&lang=js"
import style0 from "./BannerSlider.vue?vue&type=style&index=0&id=28140c19&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports